import { type JSX } from 'react'
import { Headphones } from 'lucide-react'

export default function CallCenterDashboardPage(): JSX.Element {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <Headphones className="h-12 w-12 text-slate-300 mx-auto mb-3" />
        <h2 className="text-lg font-semibold text-slate-700">Call Center Dashboard</h2>
        <p className="text-sm text-slate-400 mt-1">Coming soon</p>
      </div>
    </div>
  )
}
